
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 1.9a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm3.935 3.565c1.979 1.98 2.117 5.005.625 7.126L5.809 4.84c2.123-1.493 5.147-1.353 7.126.625zm-7.87 7.87c-1.979-1.98-2.117-5.005-.625-7.127l7.751 7.752c-2.123 1.492-5.148 1.353-7.126-.625z","fill":"#AFAFAF"}})])
          )
        }
      }
    